module.exports = __webpack_public_path__ + "img/login.8caf2baa.png";